/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { TasksApi, UpdateTaskDataMultipleCharge } from "client";
import { Const } from "const";
import { useApiWithTimeout } from "hooks/ApiWrapperWithTimeout";
import { useCallApi } from "hooks/CallApiHook";
import { useWaitTaskStatus } from "hooks/WaitTaskStatusHook";
import { useCallback, useState } from "react";
import { useRegisteredMultipleChargeTasks } from "./GetMultipleChargeTasksHook";

export const useUpdateMultipleChargeTasks = () => {
  const [updateTask, updateTaskCanceler] = useApiWithTimeout(
    TasksApi,
    Const.operationTimeout.updateTask
  );
  const [request, setUpdateRequest] = useState<UpdateTaskDataMultipleCharge>();
  const { getMultipleChargeTasks, canceler: getMultipleChargeTasksCanceler } =
    useRegisteredMultipleChargeTasks();
  const waitTaskStatus = useWaitTaskStatus();

  const cancelCallback = useCallback(() => {
    updateTaskCanceler();
    getMultipleChargeTasksCanceler();
  }, [updateTaskCanceler, getMultipleChargeTasksCanceler]);

  const result = useCallApi(
    async () => {
      if (request !== undefined) {
        // TODO: 充電運行計画のタスク更新APIを呼び出す
        await updateTask.updateTaskMultipleCharge({
          updateTaskDataMultipleCharge: request,
        });

        // TODO: ジョブセット状態がタスク承認待ち(6)になるまで待つ
        await waitTaskStatus(
          request.jobSetId,
          [Const.jobsetStatus.notApproved],
          Const.operationTimeout.getTaskCreationProgress
        );

        // Get updated jobset
        const jobset = await getMultipleChargeTasks(request.jobSetId);
        if (jobset === undefined) {
          throw new Error("Updated jobset not found");
        }
        return jobset;
      }
    },
    cancelCallback, // TODO: キャンセル時処理
    [
      request,
      cancelCallback,
      updateTask,
      getMultipleChargeTasks,
      waitTaskStatus,
    ] // TODO: 依存配列を作成する
  );

  return { ...result, setUpdateRequest };
};
